<template>

    <footer id="colophon" class="site-footer">
        <!-- Footer  Inner -->
        <div class="inner">

            <div class="content">

                <p class="title">Look what you’ve unearthed</p>

                <!-- Footer Objects -->
                <ul class="footer-objects">
                    <!-- Object One -->
                    <!--<li>-->
                    <!--<div class="object circle">-->
                    <!--<div class="content">-->
                    <!--<div class="content-front object-one"></div>-->
                    <!--<div class="content-back">-->
                    <!--<p><strong>New Website</strong> launched here, right here. Look!</p>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</li>-->
                    <!-- End Object One -->

                    <!-- Object Two -->
                    <li>
                        <div class="object square">
                            <div class="content">
                                <div class="content-front object-weather" :class="weather.currentCondition"></div>
                                <div class="content-back">
                                    <p>Here in Derby</p>
                                    <h3>{{ Math.floor(weather.main.temp - 273.15) }}&deg;</h3>
                                    <p v-if="weather.weather[0]">and there's {{ weather.weather[0].description }}!</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- End Object Two -->

                    <!-- Object Three -->
                    <li>
                        <div class="object square">
                            <div class="content">
                                <div :class="{'office-open': open}" class="content-front object-strava"></div>
                                <div class="content-back">
                                    <p v-if="open">We're open today from 9am - 5:30pm</p>
                                    <p v-else>We're closed but will be open soon!</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- End Object Three -->

                    <!-- Object Four -->
                    <li>
                        <div class="object circle">
                            <div class="content">
                                <div class="content-front object-drinks" :class="timeClass"></div>
                                <div class="content-back">
                                    <p v-if="timeClass == 'soon'">{{timeLeft}}</p>
                                    <p v-else>Gone T' Pub!</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- End Object Four -->

                    <!-- Object Five -->
                    <li>
                        <div class="object square">
                            <div class="content">
                                <div v-if="currentlyListening.image[3]" class="content-front object-music" v-lazy:background-image="currentlyListening.image[3]['#text']  || '/album-art.png'"></div>
                                <div v-else v-lazy:background-image="'/album-art.png'"></div>
                                <div class="content-back">
                                    <p><strong>Now Playing</strong></p>
                                    <p>{{ currentlyListening.artist['#text'] }}<br/>{{ currentlyListening.name }}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- End Object Five -->

                </ul>
                <!-- End Footer Objects -->

                <a class="back-to-top" @click="scrollToTop"><strong>&uarr;</strong> Back to Top</a>

                <div class="footer-collaterals">
                    <div>
                        <p class="handmade">© Alt Design {{ year }}&nbsp;&nbsp;Company Reg: 4682630&nbsp;&nbsp;<router-link to="/cookie-policy">Privacy & Cookie Policy</router-link>
                        </p>
                    </div>
                    <div>
                        <p class="handmade">Handmade in Derbyshire</p>
                    </div>
                    <div>
                        <p class="address handmade">Thorncliffe House, 278 Uttoxeter New Rd, Derby DE22 3LN</p>
                    </div>
                </div>

            </div>
        </div>
        <!-- End Footer Inner -->
    </footer>
</template>

<script>
  import Jump from 'jump.js'
  import Countdown from 'countdown-js'
  import axios from 'axios'
  // import CryptoJS from 'crypto-js'

  export default {
    data () {
      return {
        timeLeft: '',
        timeClass: '',
        currentlyListening: {
          track: '',
          artist: '',
          image: []
        },
        weather: {
          temp: '',
          currentCondition: '',
          conditions: '',
          main: { temp: 0 },
          weather: [{description: ''}]
        },
        scrollParts: {},
        open: true,
        year: 2017
      }
    },
    methods: {
      // Scroll to top button
      scrollToTop () {
        Jump('html', {duration: 500})
      },
      // Sets the margin for the scrolling of the bottom
      setFooterMargin () {
        if (document.documentElement.clientWidth > 1024) {
          document.querySelector('.site-content').style.marginBottom = document.querySelector('.site-footer').offsetHeight + 'px'
        }
      },
      // Handles the triggering of the footer objects.
      handleTrigger () {
        // Check current scroll
        let scrollTop = window.pageYOffset
        let trigger = document.body.scrollHeight - this.scrollParts.colophonInfo.height

        // Do we need this to be displayed?
        this.scrollParts.header.style.display = (scrollTop + this.scrollParts.offset > trigger) ? 'none' : 'block'

        // If we've scrolled far enough. Kill it if not - or if it has already triggered.
        if (!this.scrollParts.triggered && scrollTop + this.scrollParts.offset > trigger) {
          // Let's stop further triggers
          this.scrollParts.triggered = true
          let footerObjects = document.querySelectorAll('.footer-objects .object')

          // Loop through the objects, do a simple rollover.
          for (let index in footerObjects) {
            // Check's if this is an actual object
            if (footerObjects[index].classList) {
              // Roll in
              setTimeout(() => {
                footerObjects[index].classList.toggle('hover')
              }, 150 * index)
              // Roll out (Geodude)
              setTimeout(() => {
                footerObjects[index].classList.toggle('hover')
              }, 750 + (150 * index))
            }
          }
        }
      },
      // Defaults our scrolly parts.
      setupParts () {
        this.scrollParts = {
          header: document.querySelector('header'),
          colophonInfo: document.getElementById('colophon').getBoundingClientRect(),
          offset: (document.getElementById('colophon').getBoundingClientRect().height / 4) * 3,
          triggered: false
        }
        window.addEventListener('scroll', this.handleTrigger)
      },
      // Adds text to the beer time string
      addToTimeString (string, time, item) {
        // Prep part for object propertu
        let part = item + 's'
        if (time[part]) {
          // If it exists, add it to the time string
          string += time[part] + ' ' + item + ((time[part] > 1) ? 's' : '') + ' '
        }

        return string
      },
      // Returns the time string for beer countdown
      getTimeString (t) {
        // Setup Variables
        let returnString = 'Only '
        let parts = ['day', 'hour', 'minute', 'second']

        // Loop through the parts, add to the strings
        for (let part of parts) {
          returnString = this.addToTimeString(returnString, t, part)
        }

        // Return the String
        return returnString + ' until Friday drinky poos!'
      },
      // Performs the calculations for the TTB
      beerTimer () {
        // Setup the dates
        let beers = new Date()
        let now = new Date()
        beers.setDate(now.getDate() + (12 - now.getDay()) % 7)
        beers.setHours(16, 30, 0)

        // Perform the countdown
        Countdown.timer(beers, t => {
          // Before the time
          this.timeLeft = this.getTimeString(t)
          this.timeClass = 'soon'
        }, () => {
          // After the time
          this.timeClass = 'now'
        })
      },
      // What are we playing right now?
      nowPlaying () {
        // Setup our API url
        let lastfmURL = 'https://ws.audioscrobbler.com/2.0/?method=user.getrecenttracks&user=alt-design&api_key=544769f69c31f6a0d20b0ddd18f83c54&limit=1&format=json'

        // Perform the GET request
        axios.get(lastfmURL).then(response => {
          // Set the currently Listening
          this.currentlyListening = response.data.recenttracks.track[0]
        })
      },
      // Gets the current weather from the Yahoo API
      derpWeather () {
        this.weather.temp = '5'
        this.weather.currentCondition = 'rain'
        this.weather.text = 'raining'
        return true
      },
      currentWeather () {
        // Setup our API url
        // let weatherURL = 'https://query.yahooapis.com/v1/public/yql?q=select%20item.condition%20from%20weather.forecast%20where%20woeid%20%3D%2018114%20and%20u%20%3D%20\'c\'&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys'

//         var url = 'https://weather-ydn-yql.media.yahoo.com/forecastrss'
//         var method = 'GET'
//         // var appId = 'HqPRxm7k'
//         var consumerKey = 'dj0yJmk9Q21WMHZpd0RuWGVhJnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PWYw'
//         var consumerSecret = '55baa5f1ae5bfa275835877a55346ef6040dc898'
//         var concat = '&'
//         var query = {'location': 'derby, uk', 'format': 'json'}
//         var oauth = {
//           'oauth_consumer_key': consumerKey,
//           'oauth_nonce': Math.random().toString(36).substring(2),
//           'oauth_signature_method': 'HMAC-SHA1',
//           'oauth_timestamp': parseInt(new Date().getTime() / 1000).toString(),
//           'oauth_version': '1.0'
//         }
//
//         var merged = {...query, ...oauth}
//
// // Note the sorting here is required
//         var mergedArr = Object.keys(merged).sort().map(function (k) {
//           return [k + '=' + encodeURIComponent(merged[k])]
//         })
//         var signatureBaseStr = method +
//           concat + encodeURIComponent(url) +
//           concat + encodeURIComponent(mergedArr.join(concat))
//
//         var compositeKey = encodeURIComponent(consumerSecret) + concat
//         var hash = CryptoJS.HmacSHA1(signatureBaseStr, compositeKey)
//         var signature = hash.toString(CryptoJS.enc.Base64)
//
//         oauth['oauth_signature'] = signature
        // var authHeader = 'OAuth ' + Object.keys(oauth).map(function (k) {
        //   return [k + '="' + oauth[k] + '"']
        // }).join(',')

        // Perform the GET request
        axios.get('https://api.openweathermap.org/data/2.5/weather?q=Derby,Derbyshire,GB&appid=a582955bc678f1f781359597f869ad62').then(weatherResponse => {
          // Set our weather object
          this.weather = weatherResponse.data

          // Setup the potential conditions https://developer.yahoo.com/weather/documentation.html
          let conditions = {
            'sun': [701, 711, 721, 731, 741, 751, 761, 762, 771, 781, 800],
            'wind': [],
            'rain': [300, 301, 302, 310, 311, 312, 313, 314, 321, 500, 501, 502, 503, 504, 511, 520, 521, 522, 531],
            'thunder': [200, 201, 202, 210, 211, 212, 221, 230, 231, 232],
            'snow': [600, 601, 602, 611, 612, 613, 615, 616, 620, 621, 622]
          }

          // Default to Clouds
          this.weather.currentCondition = 'clouds'

          // Loop through the conditions find the correct one
          for (let [key, items] of Object.entries(conditions)) {
            if (items.includes(this.weather.weather[0].id)) {
              this.weather.currentCondition = key
              break
            }
          }
        })
      },
      // Works out if we're open
      openingTimes () {
        var d = new Date()
        var n = d.getDay()
        var now = d.getHours() + '.' + d.getMinutes()
        var weekdays = [
          ['Sunday'],
          ['Monday', 9.00, 17.30],
          ['Tuesday', 9.00, 17.30],
          ['Wednesday', 9.00, 17.30],
          ['Thursday', 9.00, 17.30],
          ['Friday', 9.00, 17.30],
          ['Saturday'] // we are closed, sorry!
        ]
        var day = weekdays[n]

        this.open = (now > day[1] && now < day[2] || now > day[3] && now < day[4])
      }
    },
    // Do these as early as possible
    created () {
      this.nowPlaying()
      this.currentWeather()
      this.beerTimer()
    },
    // Do these when the DOM is ready
    mounted () {
      this.setupParts()
      this.setFooterMargin()
      this.openingTimes()

      let d = new Date()
      this.year = d.getFullYear()

      window.addEventListener('resize', this.setFooterMargin)
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Footer/Footer.vue